import script from "./EventsTicketsBuyPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./EventsTicketsBuyPage.vue?vue&type=script&setup=true&lang=ts"

import "./EventsTicketsBuyPage.vue?vue&type=style&index=0&id=5152019e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5152019e"]])

export default __exports__